import * as React from "react";
const SvgCheckedBold = (props) => (
  <svg
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 4 3.5 3 5-5.5"
      stroke="#fff"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCheckedBold;
